import React from 'react';
import PropTypes from 'prop-types';
import enhance from './enhance';
import styles from './styles.scss';

export const SummaryBanner = ({
  remainingQuotaLabel,
  submittedLabel,
  inCartLabel,
  remaining,
  submitted,
  inCart,
  remainingStatStyle,
  submittedStatStyle,
  inCartStatStyle,
  mini,
}) => {
  return (
    <div>
      <ul className={styles.allocationStats}>
        <li className={styles.allocationStat}>
          <span className={remainingStatStyle}>{remaining}</span>
          <span className={mini ? styles.statMiniLabel : styles.statLabel}>
            {remainingQuotaLabel}
          </span>
        </li>
        <li className={styles.allocationStat}>
          <span className={submittedStatStyle}>{submitted}</span>
          <span className={mini ? styles.statMiniLabel : styles.statLabel}>
            {submittedLabel}
          </span>
        </li>
        <li className={styles.allocationStat}>
          <span className={inCartStatStyle}>{inCart}</span>
          <span className={mini ? styles.statMiniLabel : styles.statLabel}>
            {inCartLabel}
          </span>
        </li>
      </ul>
    </div>
  );
};

SummaryBanner.propTypes = {
  remainingQuotaLabel: PropTypes.string.isRequired,
  inCartLabel: PropTypes.string.isRequired,
  submittedLabel: PropTypes.string.isRequired,
  submitted: PropTypes.any.isRequired,
  remaining: PropTypes.any.isRequired,
  inCart: PropTypes.any.isRequired,
};

export default enhance(SummaryBanner);
